/* 🤖 this file was generated by svg-to-ts */
export const iconSafepalwallet: {
  name: 'safepalwallet';
  data: string;
} = {
  name: 'safepalwallet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="#fff" d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"/><path fill="#4523E5" d="M14.84 6.02c-.61 0-1.19.24-1.62.67l-6.73 6.75c-.25.26-.38.59-.38.93s.13.67.38.93l4.41 4.42v-7.83c0-.58.47-1.06 1.05-1.06h9.27l4.79-4.81H14.83zM10.9 21.18h9.27c.58 0 1.06-.47 1.06-1.06v-7.83l4.41 4.42c.25.26.38.59.38.93s-.13.67-.38.93l-6.73 6.75c-.43.43-1.01.67-1.62.67H6.11z"/></svg>`,
};
